var _g, _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 88,
    viewBox: "0 0 129 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2406_31492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.930786,
    width: 120.351,
    height: 49.1491,
    rx: 9.82981,
    fill: "#000929",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0908 27.5535L43.2699 26.3744C43.7497 25.8946 43.7497 25.1166 43.2699 24.6367L42.0908 23.4577",
    stroke: "#F1F5F9",
    strokeWidth: 1.84309,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.114 25.5051L36.9703 25.5051M27.7549 30.8975V20.6581M40.0421 30.8975C40.0421 32.0285 39.1253 32.9453 37.9943 32.9453H33.8985M40.0421 20.6581C40.0421 19.5271 39.1253 18.6102 37.9943 18.6102H33.8985M28.6668 33.5533L30.7147 34.9185C32.0756 35.8258 33.8985 34.8502 33.8985 33.2146V18.3409C33.8985 16.7053 32.0756 15.7297 30.7147 16.637L28.6668 18.0022C28.0971 18.3821 27.7549 19.0215 27.7549 19.7062V31.8493C27.7549 32.5341 28.0971 33.1735 28.6668 33.5533Z",
    stroke: "#F1F5F9",
    strokeWidth: 1.84309,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2064 31.5053V18.9946H59.7568V20.3386H53.7213V24.5658H59.3658V25.9097H53.7213V30.1614H59.8545V31.5053H52.2064ZM63.367 22.1223L65.615 25.9586L67.863 22.1223H69.5246L66.4947 26.8138L69.5246 31.5053H67.863L65.615 27.8645L63.367 31.5053H61.7054L64.6865 26.8138L61.7054 22.1223H63.367ZM71.5817 35.0239V22.1223H72.9745V23.6128H73.1456C73.2514 23.4499 73.398 23.2422 73.5854 22.9897C73.7768 22.7332 74.0496 22.5051 74.4039 22.3056C74.7623 22.1019 75.247 22.0001 75.8578 22.0001C76.6479 22.0001 77.3443 22.1976 77.947 22.5927C78.5497 22.9877 79.0201 23.5477 79.3581 24.2726C79.6961 24.9975 79.8651 25.8527 79.8651 26.8382C79.8651 27.8319 79.6961 28.6933 79.3581 29.4222C79.0201 30.1471 78.5518 30.7091 77.9531 31.1082C77.3545 31.5033 76.6642 31.7008 75.8823 31.7008C75.2795 31.7008 74.7969 31.601 74.4345 31.4015C74.072 31.1978 73.7931 30.9677 73.5976 30.7112C73.4021 30.4505 73.2514 30.2347 73.1456 30.0637H73.0234V35.0239H71.5817ZM72.9989 26.8138C72.9989 27.5224 73.1028 28.1475 73.3105 28.6892C73.5182 29.2268 73.8216 29.6483 74.2207 29.9537C74.6198 30.2551 75.1085 30.4057 75.6868 30.4057C76.2895 30.4057 76.7925 30.2469 77.1956 29.9293C77.6029 29.6075 77.9083 29.1758 78.1119 28.6342C78.3196 28.0885 78.4235 27.4817 78.4235 26.8138C78.4235 26.1541 78.3217 25.5595 78.1181 25.0301C77.9185 24.4966 77.6151 24.0751 77.2079 23.7656C76.8047 23.452 76.2977 23.2952 75.6868 23.2952C75.1003 23.2952 74.6076 23.4438 74.2085 23.7411C73.8094 24.0343 73.508 24.4457 73.3044 24.9751C73.1008 25.5004 72.9989 26.1133 72.9989 26.8138ZM85.8761 31.7008C85.0291 31.7008 84.2858 31.4992 83.6464 31.096C83.0111 30.6928 82.5143 30.1288 82.1559 29.4039C81.8016 28.679 81.6245 27.8319 81.6245 26.8627C81.6245 25.8853 81.8016 25.0321 82.1559 24.3031C82.5143 23.5741 83.0111 23.0081 83.6464 22.6049C84.2858 22.2017 85.0291 22.0001 85.8761 22.0001C86.7232 22.0001 87.4644 22.2017 88.0997 22.6049C88.7391 23.0081 89.2359 23.5741 89.5902 24.3031C89.9486 25.0321 90.1278 25.8853 90.1278 26.8627C90.1278 27.8319 89.9486 28.679 89.5902 29.4039C89.2359 30.1288 88.7391 30.6928 88.0997 31.096C87.4644 31.4992 86.7232 31.7008 85.8761 31.7008ZM85.8761 30.4057C86.5196 30.4057 87.049 30.2408 87.4644 29.9109C87.8798 29.5811 88.1873 29.1473 88.3868 28.6098C88.5864 28.0722 88.6861 27.4898 88.6861 26.8627C88.6861 26.2355 88.5864 25.6511 88.3868 25.1095C88.1873 24.5678 87.8798 24.13 87.4644 23.7961C87.049 23.4622 86.5196 23.2952 85.8761 23.2952C85.2327 23.2952 84.7033 23.4622 84.2879 23.7961C83.8725 24.13 83.565 24.5678 83.3654 25.1095C83.1659 25.6511 83.0661 26.2355 83.0661 26.8627C83.0661 27.4898 83.1659 28.0722 83.3654 28.6098C83.565 29.1473 83.8725 29.5811 84.2879 29.9109C84.7033 30.2408 85.2327 30.4057 85.8761 30.4057ZM92.3285 31.5053V22.1223H93.7213V23.5395H93.819C93.99 23.0753 94.2996 22.6986 94.7475 22.4094C95.1955 22.1203 95.7005 21.9757 96.2625 21.9757C96.3684 21.9757 96.5007 21.9777 96.6596 21.9818C96.8184 21.9859 96.9385 21.992 97.02 22.0001V23.4662C96.9711 23.454 96.8591 23.4357 96.684 23.4112C96.513 23.3827 96.3317 23.3685 96.1403 23.3685C95.6842 23.3685 95.277 23.4642 94.9186 23.6556C94.5643 23.8429 94.2833 24.1036 94.0756 24.4375C93.8719 24.7674 93.7701 25.1441 93.7701 25.5676V31.5053H92.3285ZM103.397 22.1223V23.3441L98.5349 23.3441V22.1223L103.397 22.1223ZM99.9522 19.8743H101.394V28.8175C101.394 29.2247 101.453 29.5302 101.571 29.7338C101.693 29.9333 101.848 30.0677 102.035 30.137C102.227 30.2021 102.428 30.2347 102.64 30.2347C102.799 30.2347 102.929 30.2266 103.031 30.2103C103.133 30.1899 103.214 30.1736 103.275 30.1614L103.569 31.4564C103.471 31.4931 103.334 31.5297 103.159 31.5664C102.984 31.6071 102.762 31.6275 102.493 31.6275C102.086 31.6275 101.687 31.5399 101.296 31.3648C100.909 31.1897 100.587 30.9229 100.331 30.5646C100.078 30.2062 99.9522 29.7541 99.9522 29.2084V19.8743Z",
    fill: "#F1F5F9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.2822,
    y: 50,
    width: 4,
    height: 36,
    fill: "#000929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7822 80L41.7822 85.5L44.2822 80",
    stroke: "#16A34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7822 76V85",
    stroke: "#16A34A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2822 84.4737L76.2822 86.5L78.7822 84.4737",
    stroke: "#16A34A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2822 83V86.3158",
    stroke: "#16A34A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2822 86.5H86.2822",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2406_31492",
    x: 0.777111,
    y: 0.930786,
    width: 126.797,
    height: 55.5948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.22289
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2406_31492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2406_31492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.929aa871e17767a39e057074129f2de8.svg";
export { ForwardRef as ReactComponent };